import { Injectable } from '@angular/core';
import { MainService } from "./main.service";
import { HttpClient } from "@angular/common/http";
import { ToastService } from 'src/app/services/toast.service';
import { StorageService } from 'src/app/services/storage.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService extends MainService {

	maintenanceMode:any = null;
	isToastMessageDisplayed:boolean = false;

	constructor(
		public http: HttpClient,
		public toastService: ToastService,
		public storage: StorageService,
		public router: Router,
	) {
		super(http, toastService, storage, router);
	}

	getMaintenanceMessage(){
		this.doRequest(this.getStoreUrl('/V1/hnd-common/configuration/hndgeneral/frontendmaintenanceflag'), '', 'GET')
		.then((result:any) => {
			if(!result.error && result.result){
				if( parseInt(result.result['active']) == 1){
					this.maintenanceMode = result.result;
					if(!this.isToastMessageDisplayed){
						this.isToastMessageDisplayed = true;
						this.toastService.add(result.result['message'], 'warning', 0);
					}
				}
				else {
					this.isToastMessageDisplayed = false;
					this.maintenanceMode = null;
				}
			}
		});
	}
}
